<header class="app-header">
    <navbar></navbar>
</header>
<div class="content" *ngIf="status === InitStatus.Ready">
    <section class="container" *ngIf="status === InitStatus.Ready">
        <api-keys [appData]="appData"></api-keys>
    </section>
</div>
<div class="loading" *ngIf="status === InitStatus.Loading">
    <span class="icon is-large has-text-primary">
        <i class="mdi mdi-loading mdi-spin mdi-48px" aria-hidden="true"></i>
    </span>
</div>
<toast></toast>
<confirm-dialog></confirm-dialog>



// WEBPACK FOOTER //
// ./src/main/components/root/root.component.html